var _metadata, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightBlueFish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 875.88501,
    height: 656.15442,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "light blue fish") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata6"
  }, "image/svg+xmlrybaVaclavek DavidZS a MS Machovo nam.czrybafish")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.871496, 0, 0, 0.857415, 55.1795, -5.86944)",
    id: "g13699"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: "m371.024536,575.333984l0.28125,0.5625c-41.91861,89.379089 57.397614,128.870117 64.15625,131.4375l0.125,0.25c0.030457,-0.064148 0.063477,-0.123413 0.09375,-0.1875c0.109558,0.040955 0.4375,0.1875 0.4375,0.1875l10.740906,-43.863708c41.920471,-89.380188 -68.419708,-85.568909 -75.178406,-88.136292l-0.125,-0.25c-0.030518,0.06427 -0.063354,0.12323 -0.09375,0.1875c-0.109528,-0.040955 -0.4375,-0.1875 -0.4375,-0.1875z",
    id: "path10998"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m802.25238,115.773781c32.524841,-29.198608 98.488281,-61.128082 136.654236,-64.248722c-66.303711,53.078831 -66.484741,85.226925 -73.307739,129.948818c-6.822998,44.721909 -31.784851,104.414459 -29.228455,191.338898c2.334106,79.364136 32.144043,153.887726 38.554443,200.358551c6.4104,46.470764 2.584229,85.815735 63.07782,135.664429c-37.249573,-2.304077 -119.380371,-45.230652 -133.50824,-58.795837c-55.16803,-52.971008 -35.342957,-128.246033 -25.104492,-171.908569c17.701538,-75.489014 -25.090088,-44.89267 -39.001282,-98.250153c13.911194,-53.357513 55.868286,-26.254242 39.283264,-100.525665c-8.56958,-38.376266 -32.233459,-114.373657 22.580444,-163.581749z",
    id: "rect2007"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "path7373",
    d: "m802.586365,115.10981c32.524902,-29.198593 98.488281,-61.128059 136.654236,-64.248711c-66.303711,53.078835 -66.484741,85.226929 -73.307739,129.948822c-6.822937,44.721909 -31.784851,104.414474 -29.228394,191.338882c2.334045,79.364136 32.144043,153.887756 38.554443,200.358521c6.4104,46.470825 2.584167,85.815796 63.077759,135.66449c-37.249512,-2.304077 -119.380371,-45.230652 -133.508179,-58.795837c-55.168091,-52.971008 -35.342957,-128.246094 -25.104492,-171.908569c17.701477,-75.489044 -25.090149,-44.89267 -39.001343,-98.250183c13.911194,-53.357513 55.868286,-26.254242 39.283264,-100.525665c-8.569519,-38.376282 -32.233398,-114.373642 22.580444,-163.581757l0,0.000008z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m399.701904,132.790451c31.920135,-14.784164 57.417725,-25.229851 84.8927,-32.807625c27.474976,-7.577789 63.489136,-15.874496 122.677429,-23.670319c-60.113647,47.204849 -57.400818,67.51162 -37.791626,104.920341c-11.008362,-5.393265 -38.821838,-20.008682 -67.304688,-26.894653c-34.762573,-8.404129 -51.818054,-7.262451 -79.346252,-7.456833c-27.528229,-0.194382 -46.725067,5.30809 -55.441132,8.166306c-8.020294,2.630051 -3.918396,-4.206818 32.313568,-22.257217z",
    id: "path23581"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 5.668905,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m261.13974,246.970352a54.352581,54.352558 0 1 1 -108.70517,0a54.352581,54.352558 0 1 1 108.70517,0z",
    id: "path2777"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m511.230957,368.938049c0,57.469818 -22.199707,109.525818 -58.075989,147.214294c-35.876343,37.688538 -97.633972,60.568298 -123.294037,60.885376c-16.332489,0.201782 -156.191101,-33.56958 -192.067413,-71.258057c-41.126831,-35.165375 -57.613319,-61.813019 -62.64048,-98.600555c-1.965057,-23.007965 18.246643,-108.211792 60.04731,-144.930511c35.876312,-37.688522 145.485199,-101.534546 200.19162,-101.534546c54.706451,0 81.886658,23.321091 117.763,61.009628c35.876282,37.688522 58.075989,89.744522 58.075989,147.214371z",
    id: "path1883"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "path10986",
    d: "m511.561462,367.103271c0,57.469818 -22.199707,109.525818 -58.075989,147.214294c-35.876343,37.688538 -97.633972,60.568298 -123.294067,60.885376c-16.332489,0.201782 -162.191101,-35.56958 -198.067413,-73.257996c-41.126816,-35.165405 -51.613304,-59.81308 -56.64048,-96.600586c-1.965042,-23.007996 18.246658,-108.211823 60.04731,-144.930511c35.876312,-37.688538 145.485229,-101.534561 200.19165,-101.534561c54.706451,0 81.886658,23.321091 117.763,61.009628c35.876282,37.688538 58.075989,89.744537 58.075989,147.214355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 5.005985,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m425.38327,144.604691c-34.267426,0 -66.993744,5.684158 -96.998779,15.94455c96.536835,33.011322 164.810394,113.765152 164.810394,208.124985c0,94.359833 -68.27356,175.144928 -164.810394,208.156219c30.005035,10.260376 62.731354,15.94458 96.998779,15.94458c72.258881,0 137.711212,-25.10321 185.098724,-65.667358c23.693787,-20.282043 63.923218,-69.752686 116.601624,-94.257904c52.678406,-24.505219 71.806396,-24.045013 71.806396,-54.967072c0,-30.922058 -24.190002,-32.119171 -76.868408,-61.225708c-52.678467,-29.106506 -87.845825,-86.122437 -111.539612,-106.400604c-47.387512,-40.556351 -112.839844,-65.651688 -185.098724,-65.651688z",
    id: "path1874"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g9179"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 5.668905,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m283.13974,238.970261a54.352581,54.352558 0 1 1 -108.705154,0a54.352581,54.352558 0 1 1 108.705154,0z",
    id: "path1886"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m259.35495,258.577454a16.507999,15.74246 0 1 1 -33.015991,0a16.507999,15.74246 0 1 1 33.015991,0z",
    id: "path2775"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    markerStart: "none",
    strokeMiterlimit: 4,
    id: "path6337",
    d: "m298.756195,293.896179c100.449463,203.237244 -219.748322,122.898438 -219.748322,122.898438"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    id: "path9184",
    d: "m284.413391,301.704041c26.261597,-13.700104 26.261597,-13.700104 26.261597,-13.700104"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 5.005985,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "path17237",
    d: "m425.38327,144.604691c-34.267426,0 -66.993744,5.684158 -96.998779,15.94455c96.536835,33.011322 164.810394,113.765152 164.810394,208.124985c0,94.359833 -68.27356,175.144928 -164.810394,208.156219c30.005035,10.260376 62.731354,15.94458 96.998779,15.94458c72.258881,0 137.711212,-25.10321 185.098724,-65.667358c23.693787,-20.282043 63.923218,-69.752686 116.601624,-94.257904c52.678406,-24.505219 71.806396,-24.045013 71.806396,-54.967072c0,-30.922058 -24.190002,-32.119171 -76.868408,-61.225708c-52.678467,-29.106506 -87.845825,-86.122437 -111.539612,-106.400604c-47.387512,-40.556351 -112.839844,-65.651688 -185.098724,-65.651688z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g22661"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m108.451218,42.60144a41.252621,36.922199 0 1 1 -82.505278,0a41.252621,36.922199 0 1 1 82.505278,0z",
    id: "path19957"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "path19959",
    d: "m35.425369,117.302513a23.44136,21.27618 0 1 1 -46.88271,0a23.44136,21.27618 0 1 1 46.88271,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "path19961",
    d: "m81.202927,330.38916a28.649469,27.566839 0 1 1 -57.298927,0a28.649469,27.566839 0 1 1 57.298927,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m65.87973,241.449036a33.895809,31.730591 0 1 1 -67.79161,0a33.895809,31.730591 0 1 1 67.79161,0z",
    id: "path19963"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "path19965",
    d: "m-11.62279,174.326401a21.350559,19.185341 0 1 1 -42.701108,0a21.350559,19.185341 0 1 1 42.701108,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m55.313438,136.054596a26.577681,24.41246 0 1 1 -53.155339,0a26.577681,24.41246 0 1 1 53.155339,0z",
    id: "path19967"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "path19969",
    d: "m157.893066,60.974098a22.56292,20.529079 0 1 1 -45.125839,0a22.56292,20.529079 0 1 1 45.125839,0z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g19946"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 2.163013,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m100.451088,52.60144a41.252621,36.922192 0 1 1 -82.505278,0a41.252621,36.922192 0 1 1 82.505278,0z",
    id: "path15447"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 3.779987,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "path15445",
    d: "m27.42532,127.302513a23.44136,21.27618 0 1 1 -46.882719,0a23.44136,21.27618 0 1 1 46.882719,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 3.00384,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "path14552",
    d: "m73.202919,340.389191a28.649469,27.566839 0 1 1 -57.298929,0a28.649469,27.566839 0 1 1 57.298929,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 2.574047,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m57.87973,251.449051a33.895809,31.730591 0 1 1 -67.79161,0a33.895809,31.730591 0 1 1 67.79161,0z",
    id: "path15439"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 4.17099,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "path15441",
    d: "m-19.62269,184.326416a21.350559,19.185341 0 1 1 -42.701109,0a21.350559,19.185341 0 1 1 42.701109,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 3.31409,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m47.313431,146.054581a26.577681,24.41246 0 1 1 -53.155341,0a26.577681,24.41246 0 1 1 53.155341,0z",
    id: "path15443"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 3.922348,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "path18138",
    d: "m149.893021,70.974083a22.56292,20.529079 0 1 1 -45.125839,0a22.56292,20.529079 0 1 1 45.125839,0z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: "m462.105164,107.209137c-44.767273,18.428146 -29.577179,36.781937 -29.577179,36.781937",
    id: "path27156"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    id: "path28946",
    d: "m537.599609,87.630493c-82.288086,25.16198 -62.737854,59.482819 -62.737854,59.482819"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    d: "m604.591125,77.296242c-106.289246,29.749237 -88.477966,80.428825 -88.477966,80.428825",
    id: "path28948"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 5.005985,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m425.38327,144.604691c-34.267426,0 -66.993744,5.684158 -96.998779,15.94455c96.536835,33.011322 164.810394,113.765152 164.810394,208.124985c0,94.359833 -68.27356,175.144928 -164.810394,208.156219c30.005035,10.260376 62.731354,15.94458 96.998779,15.94458c72.258881,0 137.711212,-25.10321 185.098724,-65.667358c23.693787,-20.282043 63.923218,-69.752686 116.601624,-94.257904c52.678406,-24.505219 71.806396,-24.045013 71.806396,-54.967072c0,-30.922058 -24.190002,-32.119171 -76.868408,-61.225708c-52.678467,-29.106506 -87.845825,-86.122437 -111.539612,-106.400604c-47.387512,-40.556351 -112.839844,-65.651688 -185.098724,-65.651688z",
    id: "path5587"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g10976"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    id: "path9185",
    d: "m557.881653,743.85968c-33.5849,62.112793 -109.381592,-9.405273 -127.876251,-40.655823c-20.997375,-33.277832 -34.915222,-77.190247 17.999969,-160.631104c7.391907,-9.692932 -4.55365,-27.643799 33.604126,-24.311829c24.735779,2.159973 3.666992,34.484192 19.950378,51.973755c18.013306,16.735107 37.724731,44.569946 50.115845,69.016907c14.301575,28.216187 23.131897,72.161804 6.205933,104.608093z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59a5f2",
    fillRule: "nonzero",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 4,
    strokeDashoffset: 0,
    d: "m557.881653,743.85968c-33.5849,62.112793 -109.381592,-9.405273 -127.876251,-40.655823c-20.997375,-33.277832 -34.915222,-77.190247 17.999969,-160.631104c7.391907,-9.692932 -4.55365,-27.643799 33.604126,-24.311829c24.735779,2.159973 3.666992,34.484192 19.950378,51.973755c18.013306,16.735107 37.724731,44.569946 50.115845,69.016907c14.301575,28.216187 23.131897,72.161804 6.205933,104.608093z",
    id: "path10081"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "svg_1",
    r: 53.712891,
    cy: 195.845581,
    cx: 250.11499,
    strokeWidth: 5,
    stroke: "#000000",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_2",
    r: 15.296875,
    cy: 219.845581,
    cx: 256.11499,
    strokeWidth: 5,
    stroke: "#000000",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "svg_11",
    r: 1,
    cy: 123.845581,
    cx: 168.11499,
    stroke: "#000000",
    fill: "#aaffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBlueFish);
export default __webpack_public_path__ + "static/media/light-blue-fish.21222a2af79e1f0e71cb8ff4613cf276.svg";
export { ForwardRef as ReactComponent };